export default __webpack_public_path__ + "static/media/betslipEmpty.7bbbe9a9.png";